import { Digtective } from '..';

export function updateKeyword(facade: Digtective, keyword?: string) {
  if (!keyword) return;
  const session = facade.getSession();
  if (session?.keyword && session.keyword !== keyword)
    return facade.updateSession({ keyword });
  return facade.updateSession({ keyword });
}
